import * as Yup from 'yup';

export const RecordSchema = Yup.object()
                               .shape({
                                          key: Yup.string()
                                                  .required('Required'),
                                      });
